import './App.css';
import React from 'react';
import 'antd/dist/antd.css';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { useLocation } from 'react-router';

import getRoutes from './routing/routes';
import { styles } from './styles';
import { Navbar, Sidebar } from './components';
import { RESET_PASSWORD_ROUTE, LOGIN_ROUTE } from './routing/paths'


const { Content } = Layout;

const App = () => {
	const location = useLocation();
	const isLogged = useSelector((state) => state.authentication.isLogged);
	const { role } = useSelector((state) => state.user.user);

	return (
		<Layout style={styles.container}>
			{(isLogged && !location.pathname.includes(RESET_PASSWORD_ROUTE) && !location.pathname.includes(LOGIN_ROUTE)) && <Sidebar />}
			<Layout className="site-layout">
				{(isLogged && !location.pathname.includes(RESET_PASSWORD_ROUTE) && !location.pathname.includes(LOGIN_ROUTE)) && <Navbar />}
				<Content style={styles.content}>
					<Switch>
						{
							getRoutes(role).map((route) => (
								<Route
									key={route.path}
									path={route.path}
									component={route.component}
									exact={route.exact}
								/>
							))
						}
					</Switch>
				</Content>

			</Layout >
		</Layout>
	);
}

export default App;
